const STORAGE_KEY = 'compliance-last-route';
const RESUME_TTL_MS = 30 * 60 * 1000; // 30 minutes

interface StoredComplianceRoute {
  path: string;
  storedAt: number;
}

const isNonListCompliancePath = (path: string): boolean =>
  path.startsWith('/compliance/') || path === '/compliance/new';

const readStoredRoute = (): StoredComplianceRoute | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  const raw = window.sessionStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as StoredComplianceRoute;
    if (!parsed?.path || typeof parsed.storedAt !== 'number') {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const setLastComplianceRoute = (path: string): void => {
  if (typeof window === 'undefined') {
    return;
  }
  if (!isNonListCompliancePath(path)) {
    return;
  }
  const payload: StoredComplianceRoute = { path, storedAt: Date.now() };
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
};

export const getLastComplianceRoute = (): string | null => {
  const stored = readStoredRoute();
  if (!stored) {
    return null;
  }
  if (Date.now() - stored.storedAt > RESUME_TTL_MS) {
    return null;
  }
  if (!isNonListCompliancePath(stored.path)) {
    return null;
  }
  return stored.path;
};

export const clearLastComplianceRoute = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  window.sessionStorage.removeItem(STORAGE_KEY);
};
